import React, {useEffect, useState} from 'react';
import './TransferLearner.scss';
import TransferLearnerKol from "./TransferLearnerKol";
import TransferLearnerJoz from "./TransferLearnerJoz";
import Loader from "../../../Loader";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import useTitle from "../../../Hooks/useTitle";

const TransferLearner = () => {

  useTitle("انتقال دانشجو");
  const [isLoad, setIsLoad] = useState(false);
  const [initialData, setInitialData] = useState([]);
  const [classesId, setClassesId] = useState({
    origin: "",
    originName: "",
    destination: "",
    destinationName: "",
  })
  const [tableData, setTableData] = useState([]);
  const [reMake, setReMake] = useState(0);

  useEffect(() => {
    _axios.get(prefixUrl() + "/learnerTransfer/?request=classList").then((response) => {
      if (response.data.status) {
        setIsLoad(true)
        setInitialData(response?.data?.data)
      } else {
        toast.error(response?.data?.message)
      }
    })
  }, [reMake]);

  useEffect(() => {
    if (classesId?.origin !== "") {
      _axios.get(prefixUrl() + "/learnerTransfer/?request=classStudents&classId=" + classesId?.origin).then((response) => {
        if (response.data.status) {
          setTableData(response?.data?.data)
        } else {
          toast.error(response?.data?.message)
        }
      })
    }
  }, [classesId?.origin]);

  const submitDataHandler = () => {
    if (classesId?.origin === "") {
      return toast.error("کلاس مبدا را انتخاب کنید")
    }
    if (classesId?.destination === "") {
      return toast.error("کلاس مقصد را انتخاب کنید")
    }

    let transferStudents = []
    if (tableData.length > 0) {
      tableData?.forEach((item) => {
        if (item?.checked === "1") {
          transferStudents.push(item?.studentId)
        }
      })
    }

    if (transferStudents.length === 0) {
      return toast.error("دانش آموزی در کلاس مبدا نیست")
    }

    _axios.post(prefixUrl() + "/learnerTransfer/", {
      request: "transferSubmit",
      transferData: {
        resourceClassId: classesId?.origin,
        destinationClassId: classesId?.destination,
        transferStudents: transferStudents,
      }
    }).then(res => {
      if (res.data.status) {
        setReMake(reMake + 1)
        setClassesId({
          origin: "",
          originName: "",
          destination: "",
          destinationName: "",
        })
        setTableData([])
        toast.success(res.data.message)
      } else {
        toast.error(res.data.message)
      }
    })
  }

  return (
    <section className={"transfer-learner"}>
      {isLoad ? <>
        <TransferLearnerKol initialData={initialData} setClassesId={setClassesId} classesId={classesId}/>
        <TransferLearnerJoz tableData={tableData} setTableData={setTableData} submitDataHandler={submitDataHandler}/>
      </> : <Loader/>}
    </section>
  );
};

export default TransferLearner;